import { combineReducers } from "redux";

import history from "./historyReducers";
import author from "./authorReducers";
import changeHistory from "./changeHistoryReducer";
import lastDiffering from "./lastDifferingReducers";
import { DISCLOSURE_FETCH_ERROR } from "../actions/historyActions";

function fetchError(state = null, action) {
    switch (action.type) {
        case DISCLOSURE_FETCH_ERROR:
            return action.payload;
        default:
            return state;
    }
}

export default combineReducers({
    history,
    changeHistory,
    author,
    lastDiffering,
    fetchError
});



/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/recommendations/disclosuresReducers.js
 **/